/**
 * Field-level errors from an API answer (docs/Decisions.md D63 item 3): a 400
 * carries `error.details.fields`, a map of `feature.field` (or `field`) to the
 * message the form shows beside that field. `prefix` strips a leading
 * `<prefix>.` so a form can key its fields by their own names.
 */
export function fieldErrorsFrom(err, prefix) {
  const fields = err?.details?.fields;
  if (!fields || typeof fields !== 'object') return {};
  if (!prefix) return { ...fields };
  const out = {};
  for (const [key, message] of Object.entries(fields)) {
    out[key.startsWith(`${prefix}.`) ? key.slice(prefix.length + 1) : key] = message;
  }
  return out;
}

/** Move keyboard focus to the first invalid control inside `root`, so the user sees it. */
export function focusFirstInvalid(root) {
  if (!root) return;
  requestAnimationFrame(() => {
    const el = root.querySelector('[aria-invalid="true"]');
    if (el) {
      el.scrollIntoView({ block: 'center', behavior: 'smooth' });
      el.focus({ preventScroll: true });
    }
  });
}
